import NTableCellLink from "./js/NTableCellLink.jsx";
import NTableCellEdit from "./js/NTableCellEdit.jsx";
import NTableCellClient from "./js/NTableCellClient.jsx";
import NTableCellChannel from "./js/NTableCellChannel.jsx";

const components = [
    NTableCellLink, NTableCellEdit, NTableCellClient, NTableCellChannel
];

export default function (app) {
    components.forEach(com => app.component(com.name, com));
};